/*** IMPORTS FROM imports-loader ***/
var define = false;

/*jslint browser: true */

"use strict";

var ko = require("knockout");
require("knockout-postbox");

var $ = require("../jquery");
var pli = require("../forms");

if (require("targetenv").isBrowser) {
    require("jquery-animate-enhanced");
}


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// FormState class
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//---------------------------------------
function FormState(crumb) {
    /// <summary>
    /// Initializes an instance of the form page
    /// used in transition.
    /// </summary>

    // find current and parent forms
    var form, c = crumb;
    while (c) {
        if (c.page.form) {
            if (form) {
                this.$parents = this.$parents ? this.$parents.add(c.page.$page) : c.page.$page;
            } else {
                form = c.page.form;
            }
        }
        c = c.previous;
    }
    this.$parents = this.$parents || $();


    this.crumb = crumb;
    this.id = (form && form.id) || "";
    this.$page = (form && form.page.$page) || $();
}


//---------------------------------------
FormState.prototype.clear = function clearFormState() {
    /// <summary>
    /// Clears custom state (styles) applied with reset.
    /// </summary>
    this.$page.removeAttr("style");
    if (this._tab) {
        this._tab.removeClass("animationActive");
        this._tab = null;
    }
};


//---------------------------------------
FormState.prototype.reset = function resetFormState(width, left) {
    /// <summary>
    /// Sets custom state (styles) of the form before transition.
    /// </summary>
    this.$page.css({ right: "auto", left: left, display: "block", width: width });
    if (this.crumb && !this.crumb.page.form) {
        this._tab = this.crumb.page.$activationIndicatedBy.add(this.crumb.page.$page);
        this._tab.addClass("animationActive");
    }
};



//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Transition class
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//---------------------------------------
function Transition(to, previous, duration) {
    /// <summary>
    /// Initializes a new form transition.
    /// </summary>
    this.previous = previous;
    this.from = (this.previous && this.previous.to) || new FormState(null);
    this.to = new FormState(to);
    this.duration = duration;
    this.up = (this.from.id.length > this.to.id.length);
    this.width = this.to.$page.width();
    this.$pages = this.to.$page.add(this.from.$page);
    this.$parents = (this.up ? this.to.$parents : this.from.$parents);
}


//---------------------------------------
Transition.prototype.execute = function executeTransition() {
    /// <summary></summary>
    // skip if form did not change
    if (this.from.id.length === 0 || this.to.id === this.from.id) { return; }
    this.previous.stop();
    this.resetState();
    this.start();
};


//---------------------------------------
Transition.prototype.resetState = function resetTransitionState() {
    /// <summary>
    /// Sets custom state (styles) of the form before transition.
    /// </summary>
    this.from.reset(this.width, 0);
    this.to.reset(this.width, (this.up ? -1 : 1) * this.width);
    this.$parents.css("display", "none");
};


//---------------------------------------
Transition.prototype.start = function startTransition() {
    /// <summary>
    /// Starts the slide animation between pages.
    /// </summary>
    this._animation = this.$pages.animate({
        left: (this.up ? "+=" : "-=").concat(this.width).concat("px"),
        avoidCSSTransitions: document.documentMode >= 8 // disable css transitions for IE (they are still flaky/crashing in IE10)
    }, this.duration, this.stop.bind(this));
};


//---------------------------------------
Transition.prototype.stop = function stopTransition() {
    /// <summary>
    /// Stop the currently running animation
    /// </summary>
    if (this._animation) {
        this._animation.stop(true, false);
        this._animation = null;
        this.from.clear();
        this.to.clear();
        this.$parents.removeAttr("style");
        this.previous = null;
    }
};



//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// TransitionsManager class
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//---------------------------------------
function TransitionsManager(duration, onBeforeTransition, onBeforeTransitionContext) {
    this._crumbsSubscription = null;
    this._duration = duration;
    this._isDisposed = true;
    this._lastTransition = null;
    this._onStateChannelSubscription = null;
    this._onBeforeTransitionSubscription = null;

    if (duration > 0) {
        this._isDisposed = false;
        this._lastTransition = ko.observable(null);

        this._onStateChannelSubscription = ko.postbox.subscribe( // start following "state" channel (this is what triggers transitions)
            "state",
            this._onStateChange,
            this, // context
            true // initializeWithLatestValue
        );

        this._onBeforeTransitionSubscription = (onBeforeTransition
            ? this._lastTransition.subscribe(onBeforeTransition, onBeforeTransitionContext)
            : null);
    }
}


//---------------------------------------
TransitionsManager.prototype.dispose = function disposeTransitionsManager() {
    var wasDisposed = this._isDisposed;
    if (!wasDisposed) {
        if (this._crumbsSubscription) {
            this._crumbsSubscription.dispose();
            this._crumbsSubscription = null;
        }
        if (this._onBeforeTransitionSubscription) {
            this._onBeforeTransitionSubscription.dispose();
            this._onBeforeTransitionSubscription = null;
        }
        if (this._onStateChannelSubscription) {
            this._onStateChannelSubscription.dispose();
            this._onStateChannelSubscription = null;
        }
        this._lastTransition = null;
        this._isDisposed = true;
    }
    return !wasDisposed;
};


//---------------------------------------
TransitionsManager.prototype.isDisposed = function isTransitionsManagerDisposed() {
    return this._isDisposed;
};


//---------------------------------------
function isCrumbModal(crumb) {
    return crumb && crumb.page && crumb.page.form && crumb.page.form.isModal;
}


//---------------------------------------
TransitionsManager.prototype._onCrumbsChange = function onTransitionManagerCrumbsChange(crumbs) {
    var lastTransition = this._lastTransition.peek();
    if (isCrumbModal(crumbs.end) || isCrumbModal(lastTransition.to.crumb)) { return; }
    var currentTransition = new Transition(crumbs.end, lastTransition, this._duration);
    this._lastTransition(currentTransition);
    currentTransition.execute();
};


//---------------------------------------
TransitionsManager.prototype._onStateChange = function onTransitionManagerStateChange(newState) {
    var crumbs = pli.forms.crumbs;
    if (newState && newState.indexOf("ready") === 0) {
        if (!isCrumbModal(crumbs.peek().end)) {
            this._lastTransition(new Transition(crumbs().end, null, this._duration));
            this._crumbsSubscription = crumbs.subscribe(this._onCrumbsChange, /*context*/ this);
        }
    } else {
        if (this._crumbsSubscription) {
            this._crumbsSubscription.dispose();
            this._crumbsSubscription = null;
        }
    }
};



//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Initialization
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

var transitionsManager = null;


//---------------------------------------
/**
 * Enable slide transitions in the current form (once it leaves initialization state).
 * Can be called multiple times (does nothing 2nd+ time).
 * @param {Object} options - Extra options for enabling slide transitions (optional).
 * @param {number} options.duration - Transition duration in milliseconds. Defaults to 300. Zero and negative values will disable transitions.
 * @param {Function} options.onBeforeTransition - Callback invoked just before a transition animation starts. Defaults to no callback.
 * @param {Object} options.onBeforeTransitionContext - Context in which "onBeforeTransition" will be called ("this" value). Defaults to undefined.
 * @returns {Object} transition manager object; it exposes a "dispose" method that will disable slide transitions when called
 */
function enableSlideTransitions(options) {
    if (!transitionsManager || transitionsManager.isDisposed()) { // prevent re-initialization
        // process options (if specified)
        var duration = 300;
        var onBeforeTransition = null;
        if (options) {
            if (typeof options !== "object") { throw new Error("\"options\" parameter for \"enableSlideTransitions\" must be an object"); }
            if (options.duration !== undefined && options.duration !== null) {
                if (typeof options.duration !== "number") { throw new Error("\"options.duration\" parameter for \"enableSlideTransitions\" must be a number"); }
                duration = options.duration;
            }
            if (options.onBeforeTransition !== undefined && options.onBeforeTransition !== null) {
                if (typeof options.onBeforeTransition !== "function") { throw new Error("\"options.onBeforeTransition\" parameter for \"enableSlideTransitions\" must be a function"); }
                onBeforeTransition = options.onBeforeTransition;
            }
        }

        // create new manager with the processed options
        transitionsManager = new TransitionsManager(duration, onBeforeTransition, options && options.onBeforeTransitionContext);
    }

    return transitionsManager;
}


//---------------------------------------
module.exports = enableSlideTransitions;
module.exports.enableSlideTransitions = enableSlideTransitions; // Export for TypeScript consumers




//////////////////
// WEBPACK FOOTER
// ./~/pli/forms-viewmodel/slideTransition.js
// module id = 471
// module chunks = 49